"use client";

import { PropsWithChildren, createContext, useContext } from "react";

/** The browser's share of the server env, built by the root layout. */
export type RuntimeConfig = {
	/** Dev console (dev panel, mock autofill, country switch). */
	devConsole: boolean;
	/** In-memory mock store instead of Goldfinger. */
	localMock: boolean;
	/** Production GA4 measurement id for this country; `null` when disabled. */
	ga4MeasurementId: string | null;
	/** Production GTM container id for this country; `null` when disabled. */
	gtmContainerId: string | null;
	/** Browser RUM and logs; `null` where telemetry is off. */
	datadog: {
		env: string | undefined;
		applicationId: string;
		clientToken: string;
	} | null;
};

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export const RuntimeConfigProvider = ({
	value,
	children,
}: PropsWithChildren<{ value: RuntimeConfig }>) => (
	<RuntimeConfigContext.Provider value={value}>
		{children}
	</RuntimeConfigContext.Provider>
);

export const useRuntimeConfig = (): RuntimeConfig => {
	const value = useContext(RuntimeConfigContext);
	if (!value) {
		throw new Error(
			"useRuntimeConfig must be used within RuntimeConfigProvider"
		);
	}
	return value;
};
